import { gql } from "lib/apolloClient";
import { basicUserFragment } from "./fragments";

export const editUserMutation = gql`
  mutation editUser(
    $firstName: String
    $middleName: String
    $lastName: String
    $pronouns: String
    $preferredName: String
    $suffix: String
    $id: ID!
    $email: String
    $profileImage: String
    $sourceId: String
    $isArchived: Boolean
    $registrationCategory: REGISTRATION_CATEGORY_TYPE_ENUM
    $yearGroupId: ID
    $addedCourses: [ID!]
    $removedCourses: [ID!]
    $courseTagMap: [CourseTagMapInput!]
    $otherDetails: OtherUserDetailsInput
    $gender: String
    $staffRelationMap: [StaffRelationMapInput!]
    $academicYearId: ID
    $isBlocked: Boolean
    $withdrawalDate: String
  ) {
    platform {
      updateUserV2(
        input: {
          id: $id
          firstName: $firstName
          middleName: $middleName
          lastName: $lastName
          pronouns: $pronouns
          preferredName: $preferredName
          suffix: $suffix
          profileImage: $profileImage
          email: $email
          sourceId: $sourceId
          isArchived: $isArchived
          isBlocked: $isBlocked
          registrationCategory: $registrationCategory
          yearGroupId: $yearGroupId
          addedCourses: $addedCourses
          removedCourses: $removedCourses
          courseTagMap: $courseTagMap
          otherDetails: $otherDetails
          gender: $gender
          staffRelationMap: $staffRelationMap
          academicYearId: $academicYearId
          withdrawalDate: $withdrawalDate
        }
      ) {
        warning
        isSuccess
        user {
          ...userItem
        }
        response {
          ...userItem
        }
      }
    }
  }
  ${basicUserFragment.user}
`;

export const deleteUserMutation = gql`
  mutation deleteUser($id: ID!) {
    platform {
      deleteUser(input: { id: $id }) {
        warning
        isSuccess
      }
    }
  }
`;
export const addUserMutation = gql`
  mutation addUser(
    $email: String
    $userType: USER_TYPE_ENUM!
    $courses: [ID!]
    $firstName: String
    $lastName: String
    $profileImage: String
    $designation: ID
    $sourceId: String
    $curriculumProgramId: ID
    $snpEvaluationCycles: [ID!]
    $tags: [ID!]
    $yearGroupId: ID
    $registrationCategory: REGISTRATION_CATEGORY_TYPE_ENUM
    $courseTagMap: [CourseTagMapInput!]
    $staffRelationMap: [StaffRelationMapInput!]
    $gender: String
    $otherDetails: OtherUserDetailsInput
  ) {
    platform {
      addUser(
        input: {
          email: $email
          userType: $userType
          courses: $courses
          firstName: $firstName
          lastName: $lastName
          profileImage: $profileImage
          designation: $designation
          sourceId: $sourceId
          curriculumProgramId: $curriculumProgramId
          snpEvaluationCycles: $snpEvaluationCycles
          tags: $tags
          yearGroupId: $yearGroupId
          registrationCategory: $registrationCategory
          courseTagMap: $courseTagMap
          staffRelationMap: $staffRelationMap
          gender: $gender
          otherDetails: $otherDetails
        }
      ) {
        ...userItem
      }
    }
  }
  ${basicUserFragment.user}
`;

export const removeCoursesFromUserMutation = gql`
  mutation removeCourseFromUser(
    $userId: ID!
    $courseIds: [ID!]
    $aclUnassignedUserRoles: [ID!]
  ) {
    platform {
      removeCourseFromUser(
        userId: $userId
        courseIds: $courseIds
        aclUnassignedUserRoles: $aclUnassignedUserRoles
      ) {
        id
      }
    }
  }
`;

export const addCoursesToUserMutation = gql`
  mutation addCourseToUser(
    $userId: ID!
    $courseIds: [ID!]
    $role: COURSE_USER_ROLE_ENUM!
    $aclAssignedUserRoles: [ACLAssignedRoleInput!]
    $courseTagMap: [CourseTagMapInput!]
    $academicYearId: ID
  ) {
    platform {
      addCourseToUser(
        userId: $userId
        courseIds: $courseIds
        role: $role
        aclAssignedUserRoles: $aclAssignedUserRoles
        courseTagMap: $courseTagMap
        academicYearId: $academicYearId
      ) {
        id
      }
    }
  }
`;

export const bulkUpdateConfigurationMutation = gql`
  mutation setConfigurationValue($input: [ConfigurationValueUpdateInput!]!) {
    platform {
      setMultipleConfigurationValueForEntityGroups(input: $input)
    }
  }
`;

export const setConfigurationValueForEntityIdsAndTypeMutation = gql`
  mutation setConfigurationValueForEntityIdsAndType(
    $input: SetConfigurationValueForEntityIdsAndTypeInput!
  ) {
    platform {
      setConfigurationValueForEntityIdsAndType(input: $input)
    }
  }
`;
